<script>
/**
 * ****************************************************************************
 * @description     :   Main component for popup Office
 * @created at      :   2024/10/21
 * @created by      :   Hainn – HaiNN@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import template
 */
import store from '@/store';
import template from './template.html';
import { mapState, mapMutations, mapActions } from 'vuex';
import PopupOffice from '@/views/popupSearch/popup_office/store';
/**
 * Define component for popup
 */

import helpers from '@/utils/helpers';

var Office = {
    template: template,
    props: {
        onSelected: Function,
        id: String,
        initData: [String, Number],
        isShowFooter: Boolean
    },
    beforeCreate() {
        if (!store.hasModule('PopupOffice')) {
            store.registerModule('PopupOffice', PopupOffice);
        }
    },
    created() {
        this.onInitScreen();
        if (this.initData) {
            this.department_cd = this.initData;
        } else {
            this.department_cd = '';
        }
        this.onSearchItem();
    },
    data() {
        return {
            department_cd: ''
        };
    },
    emits: ['close', 'onReferModelValue', 'onReferValueName'],
    computed: {
        ...mapState('PopupOffice', ['listData', 'data', 'msgNoData', 'totalRows'])
    },
    methods: {
        ...mapMutations('app', ['showHeaderError', 'showModalMessage']),
        ...mapActions('PopupOffice', ['searchOfficeInfo']),
        ...mapMutations('PopupOffice', ['resetDataInit', 'setPageNavigation', 'setPageNo']),
        onSearchItem() {
            this.setPageNavigation({
                currentPage: 1,
                perPage: this.data.pageSize
            });
            this.data.department_cd = this.department_cd;
            this.searchOfficeInfo(this.data);
        },
        changeCurrentPage(data) {
            this.data.department_cd = this.department_cd;
            this.data.pageNo = data.currentPage;
            this.data.pageSize = data.perPage;
            this.searchOfficeInfo(this.data);
        },
        onInitScreen() {
            helpers.removeAllRequireInput();
            this.resetDataInit();
        },
        chooseOffice(data) {
            this.$emit('close');
            this.$emit('onReferModelValue', data.office_cd);
            this.$emit('onReferValueName', data.office_name);
        }
    }
};
export default Office;
</script>

<style lang="scss">
@use '@/assets/scss/common/popup.scss' as *;
</style>
